/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';

import { DocumentList } from 'components/DocumentList/DocumentList';
import type { TypeDocumentListItem } from 'components/DocumentList/DocumentList';

@translate()
@inject('assetStore')
@observer
export default class AssetRelationship extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const asset: any = this.props.assetStore.asset;

    const headerTitle: React.Element<*> = (
      <React.Fragment>
        <span>{`${asset.asset_number}, ${asset.manufacturer}, ${asset.model}`}</span>
        {asset.children ? (
          <span>
            {asset.children.length}{' '}
            {t('general:assets.child_asset', {
              count: asset.children.length,
            })}
          </span>
        ) : (
          <span>{t('general:assets.parent_asset')}</span>
        )}
      </React.Fragment>
    );

    let listItems: TypeDocumentListItem = {};

    if (asset.children) {
      listItems = asset.children.toJS().map((child: Object) => ({
        icon: '#icon-sub-item',
        name: `${child.asset_number}, ${child.manufacturer}, ${child.model}`,
        secondary: `${child.description && child.description.substring(0, 80)}
                ${child.description && child.description.length > 80 ? '...' : ''}`,
        linkToButton: `/assets/${child.id}`,
      }));
    } else if (asset.parent) {
      listItems = {
        icon: '#icon-sub-item',
        name: `${asset.parent.asset_number},
                ${asset.parent.manufacturer},
                ${asset.parent.model}`,
        secondary: `${asset.parent.description && asset.parent.description.substring(0, 80)}
                ${asset.parent.description && asset.parent.description.length > 80 ? '...' : ''}`,
        linkToButton: `/assets/${asset.parent.id}`,
      };
    }

    return (
      <React.Fragment>
        <h3>{t('general:asset_relationship')}</h3>

        <DocumentList
          collapsible={true}
          header={headerTitle}
          headerUppercase={false}
          headerIcon="#icon-owned-asset"
          listItems={listItems}
        />
      </React.Fragment>
    );
  }
}
